import { hDeepCopy } from '@/utils/helpers';
import {
  FILL_LIST,
  FILL_ACTIVE_CAMPAIGN
} from './mutations-types';

export default {
  [FILL_LIST](state, payload) {
    const _state = state;
    _state.list.records = hDeepCopy(payload.records);
    _state.list.total = payload.total;
  },
  [FILL_ACTIVE_CAMPAIGN](state, payload) {
    const _state = state;
    _state.activeCampaign = payload;
  },
};
